import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const REGS = ["formal", "informal", "mixed", "neutral_na"];

// Register metadata: compact display; editable on drafts only. Never rewrites the activity text.
export default function RegisterField({ a, editable, onSaved }) {
  const { t } = useI18n();
  const [edit, setEdit] = useState(null);
  useEffect(() => setEdit(null), [a.asset_id, a.version]);
  const save = async () => {
    if (edit.register === "mixed" && !edit.note.trim()) return toast.error(t("al.reg.noteNeeded"));
    try { await api.patch(`/studio/assets/${a.asset_id}`, { register: edit.register, register_note: edit.note }); toast.success(t("al.reg.saved")); setEdit(null); onSaved?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || t("al.failed")); }
  };
  if (!edit) return (
    <div className="text-xs" data-testid="register-field">
      <b>{t("al.reg.label")}:</b> <span data-testid="register-value">{a.register ? t(`al.reg.v.${a.register}`) : t("al.reg.unspecified")}</span>
      {editable && <button onClick={() => setEdit({ register: a.register || "", note: a.register_note || "" })} className="nb-tag bg-white text-[10px] ms-2" data-testid="register-edit">{t("al.reg.edit")}</button>}
      {a.register_note && <p className="text-gray-600" dir="auto" data-testid="register-note">{a.register_note}</p>}
    </div>
  );
  return (
    <div className="text-xs space-y-1" data-testid="register-editor">
      <select className="nb-input w-auto py-1 text-xs" value={edit.register} onChange={(e) => setEdit({ ...edit, register: e.target.value })} data-testid="register-select">
        <option value="" disabled>{t("al.reg.choose")}</option>{REGS.map((r) => <option key={r} value={r}>{t(`al.reg.v.${r}`)}</option>)}</select>
      <input className="nb-input py-1 text-xs" dir="auto" maxLength={300} placeholder={t(edit.register === "mixed" ? "al.reg.notePhMixed" : "al.reg.notePh")} value={edit.note} onChange={(e) => setEdit({ ...edit, note: e.target.value })} data-testid="register-note-input" />
      <div className="flex gap-2"><button disabled={!edit.register} onClick={save} className="nb-btn-primary py-1 px-3 text-xs disabled:opacity-50" data-testid="register-save">{t("al.save")}</button>
        <button onClick={() => setEdit(null)} className="nb-btn-outline py-1 px-3 text-xs" data-testid="register-cancel">{t("al.cancel")}</button></div>
    </div>
  );
}
